import React from "react";

import { makeStyles } from "@material-ui/core/styles";

const TextError = ({ children }) => {
  const classes = useStyles();
  return <div className={classes.listError}>{children}</div>;
};

const useStyles = makeStyles((theme) => {
  return {
    listError: {
      fontSize: ".79rem",
      marginLeft: "1rem",
      marginTop: ".2rem",
      marginRight: "1rem",
      color: theme.palette.error.main,
    },
  };
});

export default TextError;
